/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {
    ACCEPT_TERMS_AND_CONTINUE: 'Accetta e continua',
    APPROVE: 'Approva',
    CANCEL: 'Cancella',
    SAVE: 'Salva'
  },
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_CHECKBOX: 'Ho letto e accetto i Termini e Condizioni',
    ACCEPT_TERMS_DESCRIPTION:
      'Prima di accedere alla piattaforma Prozis Partnership, leggi e accetta i Termini e Condizioni del Prozis Influencer Program.',
    ACCEPT_TERMS_NAV_TITLE: 'Termini e Condizioni',
    ACCEPT_TERMS_SCROLL_HINT: 'Leggi fino alla fine per continuare.',
    DASHBOARD: 'Pannello di controllo',
    ENABLE_NOTIFICATIONS_DESCRIPTION:
      'Abbiamo notato che non hai notifiche attive, per poter continuare a utilizzare l\'app abbiamo bisogno che tu attivi le notifiche.',
    ENABLE_NOTIFICATIONS_LINK: 'Puoi attivare le notifiche qui',
    ENABLE_NOTIFICATIONS_NAV_TITLE: 'Notifiche',
    ENABLE_NOTIFICATIONS_TITLE: 'Attiva le notifiche per poter continuare',
    HOME: 'Home',
    INSTALL_PROZIS_APP: 'Installare l\'applicazione Prozis Store',
    INSTALL_PROZIS_APP_DESCRIPTION:
      'Installate la nostra applicazione mobile per continuare ad accedere a tutte le funzioni.',
    INSTALL_PROZIS_APP_NAV_TITLE: 'Installa l\'app',
    LOGOUT: 'Logout',
    NOT_FOUND: 'Nessun risultato',
    OR: 'Oppure',
    OR_SCAN_QR_CODE: 'Oppure scansionate il codice QR',
    SCAN_QR_CODE: 'Scansionate il codice QR con il vostro dispositivo mobile',
    TODOS: 'Tutti',
    UNAUTHORIZED_DESCRIPTION_1:
      'Verifica con il tuo manager i permessi di accesso.',
    UNAUTHORIZED_DESCRIPTION_2: 'Dopo la verifica, prova ad accedere di nuovo.',
    UNAUTHORIZED_NAV_TITLE: 'Accesso negato',
    UNAUTHORIZED_TITLE: 'Nessun permesso di accesso'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
